import { EncryptStorage } from 'encrypt-storage';

export const encryptStorage = EncryptStorage('Foodhub2021', {
    storageType:'localStorage'
});